import React from 'react';

import './styles.scss';

const Spin = () => {
  return <div className="loader">Loading...</div>;
};

export default Spin;

const loadingWrapper = (className) => () =>
  (
    <div className={className}>
      <Spin />
    </div>
  );

export const LoadingScreen = loadingWrapper('loading-screen');
